export const ROUTE_PATH = '/parking';

export const FEATURE_NAME = 'parkingPage';

export const RESOURCE_NAME = 'parking';

export const RESOURCE_RATE_NAME = 'parking-rate';
